import { render, staticRenderFns } from "./RequestComponent.vue?vue&type=template&id=079a9e2a&scoped=true&"
import script from "./RequestComponent.vue?vue&type=script&lang=js&"
export * from "./RequestComponent.vue?vue&type=script&lang=js&"
import style0 from "./RequestComponent.vue?vue&type=style&index=0&id=079a9e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079a9e2a",
  null
  
)

export default component.exports